<template>
  <div class="results-actions">
    <div v-if="categories" class="action">
      <icon-button
        type="button"
        icon="category"
        label="Categories"
        classes="category"
        :icons-outlined="false"
        :aria-expanded="activeExpander === 'categories'"
        :aria-controls="accessibilityExpanderId"
        @click-action="toggleControl('categories')"
      />
    </div>
    <div v-if="shelf" class="action">
      <icon-button
        type="button"
        icon="bookmarks"
        label="Shelf"
        classes="category"
        :icons-outlined="false"
        :aria-expanded="activeExpander === 'shelf'"
        :aria-controls="accessibilityExpanderId"
        @click-action="toggleControl('shelf')"
      />
    </div>
    <div v-if="surpriseMe" class="action">
      <icon-button
        type="button"
        icon="casino"
        label="Surprise Me"
        classes="surprise"
        :icons-outlined="false"
        :aria-expanded="activeExpander === 'surprise'"
        :aria-controls="accessibilityExpanderId"
        data-tour="plus-free-access-surprise-me"
        @click-action="toggleControl('surprise')"
      />
    </div>

    <!-- slot for cms / crud / other buttons -->
    <slot />
  </div>
</template>

<script setup lang="ts">
import IconButton from '@/components/buttons/icon-button.vue'
import type { FilterCollection } from '@/types/model-types'

/** PROPS **/
withDefaults(
  defineProps<{
    shelf?: boolean
    surpriseMe?: boolean
    categories?: boolean
    activeExpander?: string
    accessibilityExpanderId: string
    filterCollection?: FilterCollection | null
  }>(),
  {
    shelf: false,
    surpriseMe: false,
    categories: false,
    activeExpander: '',
    filterCollection: null,
  },
)

/** STATE **/
// noop

/** EMITS **/
const emit = defineEmits(['expander-click'])

/** METHODS **/
function toggleControl(expander: string) {
  emit('expander-click', expander)
}
</script>
